import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

    transform(list: Array<unknown>, filter: { [key: string]: any }, isFullMatch: boolean = true): Array<unknown> {
        const filterKeys: Array<string> = Object.keys(filter || {});
        let result = list;

        if (filterKeys.length) {
            result = list.filter((listItem: unknown) =>
                filterKeys.every((filterKey: string) => {
                    if (isFullMatch) {
                        return listItem[filterKey] === filter[filterKey];
                    } else {
                        return listItem[filterKey].toLowerCase().includes(filter[filterKey].toLowerCase());
                    }
                }));
        }

        return result;
    }

}
